import { render } from "./PortfolioModal5.vue?vue&type=template&id=0f1818f0"
import script from "./PortfolioModal5.vue?vue&type=script&lang=js"
export * from "./PortfolioModal5.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__